import { useContext } from 'react';
import OverdueCountContext from '../../contexts/OverdueCountContext';

const useOverdueCountContext = () => {
  const context = useContext(OverdueCountContext);
  if (!context) {
    throw new Error('useOverdueCountContext must be used within OverdueCountContextProvider!');
  }
  return context;
};

export default useOverdueCountContext;
